import { render, staticRenderFns } from "./active-request-tab.vue?vue&type=template&id=0d16ac68&"
import script from "./active-request-tab.vue?vue&type=script&lang=js&"
export * from "./active-request-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports